import ToolbarUI from 'browse/ui/toolbar';

document.addEventListener('DOMContentLoaded', () => {
    ToolbarUI.attachTo('[data-toolbar]');
});



// WEBPACK FOOTER //
// ./src/web/js/browse/browse.js